import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import type { WebInAppID } from '@/lib/constants';
import { session } from '@/lib/storage';

export const useWebInAppStore = create(
  devtools(
    combine(
      {
        isWebInApp: false as boolean,
        webInAppID: session.getItem('webinapp') || (null as WebInAppID | null),
      },
      (set) => ({
        setWebInApp: (webInAppID: WebInAppID) => {
          if (webInAppID) {
            session.setItem('weninapp', webInAppID);
            set({ webInAppID, isWebInApp: true });
          }
        },
      })
    )
  )
);
